import { NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl';
import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

export class StreamingService {
  private isStreaming = false;

  constructor(private plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin) {}

  async start(): Promise<void> {
    if (this.isStreaming) return;

    this.isStreaming = true;
    await this.plugin.StartStreaming();
  }

  async stop(): Promise<void> {
    if (!this.isStreaming) return;

    this.isStreaming = false;
    await this.plugin.StopStreaming();
  }
}
